// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PopupAside/styles.scss
// module id = 1112
// module chunks = 0